import React from "react";
import { Reveal } from "./Reveal";

export const PageHero = ({ title, subtitle, eyebrow }) => (
  <section className="bg-[#15348C] text-white py-16 relative overflow-hidden">
    <div className="absolute -top-20 right-10 w-72 h-72 bg-[#6BBE32]/15 rounded-full blur-3xl"/>
    <div className="absolute -bottom-20 left-10 w-72 h-72 bg-[#F57C20]/15 rounded-full blur-3xl"/>
    <div className="relative max-w-7xl mx-auto px-4 text-center">
      <Reveal>
        {eyebrow && <div className="text-xs font-bold tracking-widest text-[#8BD835] mb-3">{eyebrow}</div>}
        <h1 className="text-4xl lg:text-5xl font-bold">{title}</h1>
        <p className="mt-3 text-gray-300 max-w-2xl mx-auto">{subtitle}</p>
      </Reveal>
    </div>
  </section>
);

export default PageHero;
